export const TabTitle = (newTitle) => {
  if (newTitle !== "") {
    return (document.title = "SDMPlus - " + newTitle);
  } else {
    return (document.title = "SDMPlus ");
  }
};
